export const userConstants = {
  SET_USER_DATA: "SET_USER_DATA",
  USER_SIGNED_IN: "USER_SIGNED_IN",
  USER_SIGNED_OUT: "USER_SIGNED_OUT"
};
